module.exports = __webpack_public_path__ + "img/card-checked.31697c23.svg";